import AuthService from '../../app/auth/Authorization.service';

/**
 * A identidade da sessão logada: o token de acesso guardado, lido **a cada
 * render**, ou `null` quando não há token.
 *
 * Existe para um caso concreto e nada teórico. O "Sair" do Sidebar
 * (`Sidebar.tsx:350`) só faz `navigate("/login")` — não limpa o storage e não
 * recarrega o documento, ao contrário do `logoutAndRedirect()` do Header. Um
 * segundo usuário pode então logar **na mesma aba, com o React montado o tempo
 * todo**, e qualquer dado por usuário que sobreviva a isso é notificação de um
 * usuário aparecendo para outro — o MUST NOT da spec de notificações.
 *
 * (Esse "Sair" é bug antigo e documentado no CLAUDE.md; consertá-lo é outra
 * tarefa. O que se faz aqui é não depender dele.)
 *
 * Por isso a chave é lida do storage em render, e não guardada em estado nem
 * semeada de lugar nenhum: é a leitura mais recente que manda, sem esperar um
 * efeito, um evento `storage` (que nem dispara na mesma aba) ou uma
 * remontagem. Quem consome deve **etiquetar o que buscou com a chave da época**
 * e descartar o que estiver etiquetado com outra — ver `useNotifications` e
 * `useDueCount`.
 *
 * Deliberadamente diferente do `useProfileStore`, cuja semente em
 * `localStorage` é intencional: perfil é preferência de pintura, notificação é
 * conteúdo de usuário.
 */
export default function useSessionKey(): string | null {
  return AuthService.getAccessToken();
}
